import { PRODUCT_DETAILS_FEATURE } from './../reducers/index';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProductDetails from '@product-details/store/reducers';

const getProductDetailsState =
  createFeatureSelector<fromProductDetails.ProductDetailsState>(
    PRODUCT_DETAILS_FEATURE
  );

export const getSelectedState = createSelector(
  getProductDetailsState,
  (state) => state?.selected
);

export const getSelectedOffer = createSelector(
  getSelectedState,
  (state) => state?.data
);
